import axios from "../axios/axios";
import { apiSetAlert } from "./appApi";
import { errorDispatcher, getOptionsQuery } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { selectTableItems } from "../store/actions";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import fileDownload from "js-file-download";

export const apiGetInstallmentsExcel = (token, installmentType, selectedIds) => (dispatch, getState) => {
  let url = "installments/excel/export";
  if (selectedIds && selectedIds.length > 0) {
    url += `?ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      fileDownload(response.data, "installments.xlsx");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetInstallment =
  (installmentId, token, callback, status) => (dispatch, getState) => {
    dispatch(appSetLoading());
    let params = {}
    if (status !== "installmentShow") {
      params["status"] = status
    }
    axios
      .get(`installments/${installmentId}`, {
        headers: { Authorization: `Bearer ${token}` },
        params
      })
      .then((response) => {

        // let installment = response.data.installment;
        // const Project = setSelectItemLabels(installment.Project, "id", "title");
        // const Branch = setSelectItemLabels(installment.Branch, "id", "title");
        // const Factor = setSelectItemLabels(installment.Factor, "id", "title");
        // installment = {
        //   ...installment,
        //   Project,
        //   Branch,
        //   installmentFactor: Factor,
        // };

        // dispatch(setEditItem(installment));
        dispatch(appSetLoading(false));
        callback(response?.data?.installment,response);
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiGetInstallments =
  ({ pagination, token, key, sort, search, type }) =>
    (dispatch, getState) => {
      let installmentType = type ?? key;
      let options = getOptionsQuery(pagination, search, sort);

      dispatch(appSetLoading());
      axios
        .post(`/installments/list?installmentType=${installmentType}`, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          dispatch(setTableData(response.data.installments, response.data.paginate));
          // dispatch(setInstallments(response.data.installments));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiDeleteInstallments = (selectedIds, token, t, callback) => (dispatch, getState) => {
  const installmentIds = selectedIds;
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  axios
    .delete(`/installments/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { installmentIds },
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSaveInstallment = (form, token, navigate,callBack) => (dispatch, getState) => {
  if (form.payer_type === "factor" && !form.payer_id) {
    dispatch(apiSetAlert("لطفا فاکتور مربوطه جهت تقسیط را انتخاب نمایید", "warning"));
    return;
  }

  if (!form.installmentItems || form.installmentItems.length < 1) {
    dispatch(apiSetAlert("لطفا اطلاعات اقساط را وارد نمایید ", "warning"));
    return;
  }

  const formData = form;
  dispatch(appSetSendingRequest(true));
  axios
    .post(`/installments`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if(typeof callBack ==="function"){
        return callBack(response)
      }
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/installments");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateInstallment = (installmentId, form, token, navigate,callBack) => (dispatch, getState) => {
  // const formData = setFormDataInstallment(form);

  // dispatch(appSetSendingRequest(true));
  // axios
  //   .put(`installments/${installmentId}`, formData, {
  //     headers: { Authorization: `Bearer ${token}` },
  //   })
  //   .then((response) => {
  //     dispatch(apiSetAlert(response.data.message, "success", false));
  //     navigate("/installments");
  //   })
  //   .catch((error) => {
  //     errorDispatcher(error, dispatch);
  //   });

  if (form.payer_type === "factor" && !form.payer_id) {
    dispatch(apiSetAlert("لطفا فاکتور مربوطه جهت تقسیط را انتخاب نمایید", "warning"));
    return;
  }

  if (!form.installmentItems || form.installmentItems.length < 1) {
    dispatch(apiSetAlert("لطفا اطلاعات اقساط را وارد نمایید ", "warning"));
    return;
  }

  const formData = form;
  dispatch(appSetSendingRequest(true));
  axios
    .put(`installments/${installmentId}`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      if(typeof callBack ==="function"){
        return callback(response)
      }
      navigate("/installments");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
